import DOMPurify from 'dompurify'

export { destroyTooltips, initializeTooltip, initializeTooltipWithDelay, reinitializeTooltip, reinitializeTooltipWithDelay, resizeTextAreaToFitContent, toggleSidebarMenuMobile, toggleSidebarMenuMobileAdmin, getUrlVariable, getUrlVariableArray, getUrlVariableArrayAsInt, getUrlVariableString, truncateString, closeModalOnBrowserBackButton, clearAnyTooltipRemains, getDistinctWordsCountInString, purifyHtml }

function initializeTooltip() {
	jQuery(function () {
		jQuery('.tooltip').remove() // Hard remove them from DOM.
		jQuery('[data-toggle="tooltip"]').tooltip()
	})
}

function initializeTooltipWithDelay() {
	setTimeout(function () {
		initializeTooltip()
	}, 500);
}

function destroyTooltips() {
	jQuery('[data-toggle="tooltip"]').tooltip('dispose');
}

function reinitializeTooltip() {
	jQuery(function () {
		destroyTooltips();
		jQuery('[data-toggle="tooltip"]').tooltip();
	})
}

function reinitializeTooltipWithDelay() {
	setTimeout(function () {
		reinitializeTooltip()
	}, 500);
}

// Solution inspired from here: https://stackoverflow.com/questions/995168/textarea-to-resize-based-on-content-length
function resizeTextAreaToFitContent() {
	const { textarea } = this.$refs;
	let minHeight = 17;

	if (typeof textarea === 'undefined' || textarea === null) return; // Prevent console errors for ex when on the 'Delayed Decline' modal. It is 'null' when we switch between the dropdown optiond an the textarea dissappears after it was initially visible.

	textarea.style.height = "1px";
	let actualHeight = (textarea.scrollHeight > minHeight) ? textarea.scrollHeight : minHeight;
	textarea.style.height = (25 + actualHeight) + "px";
}

function toggleSidebarMenuMobile() {
	let watchTriggers = "#dm_subheader_mobile_toggle, .dm-discussion-item, .dm-close-mobile-menu-button, .dm-profile .offcanvas-mobile .navi-item";

	jQuery(document).on('click', watchTriggers, function () {
		jQuery(".offcanvas-mobile").toggleClass("offcanvas-mobile-on");
	});

	// When the main menu is clicked, close any secondary menu.
	$('.dropdown.dropdown-inline').on('show.bs.dropdown', function () {
		$(document).find(".offcanvas-mobile").removeClass("offcanvas-mobile-on");
	})
}

function toggleSidebarMenuMobileAdmin() {
	jQuery(document).on('click', '#dm_sidebar_admin_mobile_toggle', function () {
		jQuery(".dm-dashboard-sidebar").toggleClass("dm-menu-opened");
	});

	$(document).on('click', '.dm-dashboard-sidebar.dm-menu-opened a', function () {
		$('.dm-menu-opened').removeClass('dm-menu-opened');
		$('.dm-dashboard-sidebar').removeClass('dm-menu-opened');
	});
}


function getUrlVariable(variable) {
	const urlParams = new URLSearchParams(window.location.search);
	return urlParams.get(variable);
}

function getUrlVariableArray(variable) {
	const urlParams = new URLSearchParams(window.location.search);
	let allValues = urlParams.getAll(variable)

	return (allValues) ? allValues : [];
}

function getUrlVariableArrayAsInt(variable) {
	const urlParams = new URLSearchParams(window.location.search);
	let allValues = urlParams.getAll(variable)

	let allValuesCean = (allValues) ? allValues : [];

	// ensure each item in the array is an integer
	return allValuesCean.map(function (x) {
		return parseInt(x, 10);
	});
}

function getUrlVariableString(variable) {
	let variableValue = getUrlVariable(variable);
	return (variableValue) ? variableValue : '';
}

function truncateString(str, maxLength) {
	if (!str) return '';

	if (str.length > maxLength) {
		return str.slice(0, maxLength - 3) + '...';
	}
	return str;
}


// When a modal is opened this closes the modal instead of doing a 'Back page' when the 'Back button is closed.
// Solution from here: https://stackoverflow.com/questions/16870007/how-to-close-a-bootstrap-modal-with-the-browser-back-button-instead-of-going-bac
function closeModalOnBrowserBackButton(modalId = '') {
	let selector = (modalId) ? modalId : '.modal';
	jQuery(selector).on('shown.bs.modal', function () {
		if (typeof (this.dataset.hash) !== 'undefined') {
			history.pushState(null, null, this.dataset.hash)
		}
	})

	jQuery(selector).on('hide.bs.modal', function (event) {

		if (this.dataset.pushback !== 'true') {
			// event.preventDefault()
			// history.back()
		}
		this.dataset.pushback = ''
	})

	// Close current open modal (if any) on browser back event
	window.onpopstate = function () {
		let open_modal = document.querySelector('.modal.show')
		if (open_modal) {
			open_modal.dataset.pushback = 'true';
			jQuery(open_modal).modal('hide')
		}
	}
}

function clearAnyTooltipRemains() {
	jQuery('.tooltip').remove();
}

function getDistinctWordsCountInString(someString) {
	if (!someString) return 0;

	let html = someString;

	// Replace <p><br></p> with a space to ensure separation
	html = html.replace(/<p><br\s*\/?><\/p>/gi, " ");
	html = html.replace(/<br\s*\/?>/gi, " "); // Explicitly treat <br /> as a word separator

	// Remove all other <p> tags
	html = html.replace(/<\/?p>/gi, " ");

	// Strip any remaining HTML tags safely
	const tempElement = document.createElement("div");
	tempElement.innerHTML = html;

	// Extract text and normalize whitespace
	let rawText =
		tempElement.textContent || tempElement.innerText || "";
	rawText = rawText.replace(/\s+/g, " ").trim();

	// Split into words and filter
	const wordsArray = rawText.split(" ").filter((word) => word !== "");

	return wordsArray.length;
}

function purifyHtml(content) {
	if (!content) return '';

	return DOMPurify.sanitize(content, {
		ALLOWED_TAGS: ['a', 'b', 'i', 'em', 'strong', 'u', 'p', 'br', 'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'span'],
		ALLOWED_ATTR: ['href'],
	});
}
